import { render, staticRenderFns } from "./limitHistory.vue?vue&type=template&id=2e23fcba&scoped=true"
import script from "./limitHistory.vue?vue&type=script&lang=js"
export * from "./limitHistory.vue?vue&type=script&lang=js"
import style0 from "./limitHistory.vue?vue&type=style&index=0&id=2e23fcba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23fcba",
  null
  
)

export default component.exports